
export const system = {
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL;
    }
  }
};
